import { render } from "./addtask.vue?vue&type=template&id=a82d4b14"
import script from "./addtask.vue?vue&type=script&lang=js"
export * from "./addtask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__